export const countryIdToVatNoPlaceholderTKey: Record<string, string> = {
  DE: 'external_invoices.company_information_modal.vat_no.org_DE.placeholder',
  DK: 'external_invoices.company_information_modal.vat_no.org_DK.placeholder',
  FR: 'external_invoices.company_information_modal.vat_no.org_FR.placeholder',
  NL: 'external_invoices.company_information_modal.vat_no.org_NL.placeholder',
}
